import baseApi from './baseApi'

export const overviewApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCorporateDash: builder.query({
      query: ({ id, isGroup }) => ({
        url: 'corporate_dash',
        method: 'POST',
        body: { id, isGroup },
      }),
      providesTags: ['brain_report'],
    }),
    getOverviewAnalysis: builder.query({
      query: ({ id, isGroup, gender, startDate, endDate }) => {
        const [sYear, sMonth] = startDate.split('-')
        const [eYear, eMonth] = endDate.split('-')
        return {
          url: 'overview_analysis',
          method: 'GET',
          params: {
            isGroup,
            id,
            is_gender: gender,
            start_year: sYear,
            start_month: sMonth,
            end_year: eYear,
            end_month: eMonth,
          },
        }
      },
      transformResponse: (response, meta, arg) => {
        const { average, attempted_analysis } = response
        const { specialities } = arg

        const specialitiesObj = Object.fromEntries(specialities.map(({ label, value }) => [value, label]))

        const ms = {
          Fatigue: average.difference.tired,
          Happiness: average.difference.happy,
        }

        const brainStrength = Object.entries(average).reduce((acc, [key, value]) => {
          if (Object.keys(specialitiesObj).includes(key)) {
            acc[specialitiesObj[parseInt(key)]] = value
          }
          return acc
        }, {})

        const userAnalysis = [
          attempted_analysis.gender_dis.all,
          attempted_analysis.gender_dis.M,
          attempted_analysis.gender_dis.F,
          attempted_analysis.gender_dis.unattempt,
        ]

        return { ms, brainStrength, userAnalysis }
      },
      providesTags: ['brain_report'],
    }),
  }),
  overrideExisting: false,
})

export const { useGetCorporateDashQuery, useGetOverviewAnalysisQuery } = overviewApi
export default overviewApi
